import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a94902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card shadow-sm" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title text-gray-800" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1))
const _hoisted_9 = { class: "card-body fs-4 text-gray-700" }
const _hoisted_10 = {
  key: 0,
  style: {"white-space":"pre-line"}
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "mb-8" }
const _hoisted_13 = { class: "d-flex align-items-center mb-3 ms-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot me-3 h-8px w-8px" }, null, -1))
const _hoisted_15 = { class: "fs-4 text-gray-700 w-bolder mb-0" }
const _hoisted_16 = { class: "mb-8" }
const _hoisted_17 = { class: "d-flex align-items-center mb-3 ms-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot me-3 h-8px w-8px" }, null, -1))
const _hoisted_19 = { class: "fs-4 text-gray-700 w-bolder mb-0" }
const _hoisted_20 = { class: "row gx-5 my-5" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "card card-xl-stretch" }
const _hoisted_23 = { class: "card-header" }
const _hoisted_24 = { class: "card-title text-gray-800" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "text-gray-700 fs-4" }
const _hoisted_27 = { class: "card-footer" }
const _hoisted_28 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "row d-inline-flex justify-content-around text-success" }
const _hoisted_31 = { class: "col px-0 mx-2" }
const _hoisted_32 = { class: "text-gray-700" }
const _hoisted_33 = {
  id: "days",
  class: "number fw-bold"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_35 = { class: "col px-0 mx-2" }
const _hoisted_36 = { class: "text-gray-700" }
const _hoisted_37 = {
  id: "hours",
  class: "number fw-bold"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_39 = { class: "col px-0 mx-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Min", -1))
const _hoisted_41 = {
  id: "minutes",
  class: "number fw-bold"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_43 = { class: "col px-0 mx-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Seg", -1))
const _hoisted_45 = {
  id: "seconds",
  class: "number fw-bold"
}
const _hoisted_46 = { class: "my-5 d-flex flex-column" }
const _hoisted_47 = { class: "upload-container card" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = { class: "text-gray-800" }
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "file-input-wrapper" }
const _hoisted_52 = {
  for: "file",
  class: "file-label"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-arrow-up text-white fs-3 me-2" }, null, -1))
const _hoisted_54 = { class: "mb-3" }
const _hoisted_55 = {
  key: 0,
  class: "file-preview"
}
const _hoisted_56 = { class: "file border border-gray-500" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-pdf text-primary fs-3" }, null, -1))
const _hoisted_58 = { class: "text-gray-800 fs-4" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle text-danger text-hover-success fs-3" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 1,
  class: "file-preview"
}
const _hoisted_62 = { class: "file border border-gray-400" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-fill text-gray-400 text-hover-gray-500 fs-3" }, null, -1))
const _hoisted_64 = { class: "text-gray-400 fs-4 text-hover-gray-500" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer mt-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-circle-fill text-gray-400 text-hover-gray-500 fs-3" })
], -1))
const _hoisted_66 = { class: "d-flex flex-column" }
const _hoisted_67 = { class: "justify-content-start d-flex align-items-center" }
const _hoisted_68 = { class: "" }
const _hoisted_69 = {
  key: 0,
  class: "text-danger fs-8 text-opacity-50"
}
const _hoisted_70 = {
  key: 1,
  class: "text-success fs-8 text-opacity-50"
}
const _hoisted_71 = { class: "row mt-5 mx-1" }
const _hoisted_72 = { class: "card" }
const _hoisted_73 = { class: "card-body" }
const _hoisted_74 = { class: "d-flex flex-column" }
const _hoisted_75 = { class: "justify-content-center d-flex align-items-center" }
const _hoisted_76 = { class: "" }
const _hoisted_77 = {
  key: 1,
  class: "upload-btn-disabled bg-gray-300 text-gray-500"
}
const _hoisted_78 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_79 = { class: "container text-center mt-5" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_81 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import {computed, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import CardMachine from "@/components/certification/CardMachine.vue";
import {Actions} from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import moment from "moment";
import { useCertificationSteps } from "@/core/composables/useCertificationSteps";
import { formatBrasilia } from "@/core/helpers/dates";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



// Composable para gerenciar steps da certificação
const {
  loading: configLoading,
  strategyType,
  currentStep,
  steps,
  expectedStepForComponent,
  isOnCorrectStep,
  getNextStepRoute,
  getPreviousStepRoute,
  getStepRoute,
  loadCertificationData,
  statusData,
  configData,
  getStepByType,
} = useCertificationSteps(props.id, 'certification_report');

const reportStep = computed(() => getStepByType('report'));
const reportTitle = computed(() => reportStep.value?.title?.trim() || null);
const reportMessage = computed(() => reportStep.value?.message?.trim() || null);

const store = useStore();
const router = useRouter();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const certificationOK = ref(true);
const file = ref();
const terms = ref(false);
const isChecked = ref(false);
const sendReportLoading = ref(false);
const isFile = ref(false)
const loading = ref(false);
const deadlineSendReport = ref()
const intervalId = ref<number>();
const timeRemaining = ref<{ days: number, hours: number, minutes: number, seconds: number }>({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
});
const timeSmall = ref(false);
const startDate = ref(); // Data de início vinda do backend

// Início do prazo deste step vem direto do backend (current_step_started_at), com fallback
const created_at = computed(() => statusData.value?.current_step_started_at ?? statusData.value?.created_at ?? null);

onBeforeUnmount(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
  }
});

const calculateTimeRemaining = () => {
  const now: any = new Date();
  const end: any = deadlineSendReport.value ? moment.utc(deadlineSendReport.value).toDate() : null;

  const difference = end ? end - now : 0;
  if (difference > 0) {
    timeRemaining.value = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  } else {
    timeRemaining.value = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
};
const getDeadlineSendReport = async () => {
  try {
    loading.value = true;
    const {status, data} = await ApiService.get(`/certification/status/${props.id}`);
    if (status === 200) {
      // Busca o deadline de envio de relatório
      // O backend popula este campo baseado no deadline_days do step de report
      deadlineSendReport.value = data.data.deadline_send_report;
      // Busca a data de início (se o backend fornecer)
      startDate.value = data.data.start_date || data.data.created_at;
      calculateTimeRemaining();

      intervalId.value = window.setInterval(() => {
        calculateTimeRemaining();
        if( (timeRemaining.value.days === 0 &&
            timeRemaining.value.hours === 0 &&
            timeRemaining.value.minutes === 0 &&
            timeRemaining.value.seconds <= 1)
        )
        {
          clearInterval(intervalId.value);
          timeSmall.value = true;
        }
      }, 1000);
    }
  } catch (e) {
    console.error("Erro ao buscar o deadline:", e);
  }finally {
    loading.value = false;
  }
};

watch(timeSmall, (newValue) => {
  if (newValue) {
    const now: any = new Date();
    const end: any = deadlineSendReport.value ? moment.utc(deadlineSendReport.value).toDate() : null;
    if(end && now >= end) {
      redirectFeedBack();
    };
  }
});

const redirectFeedBack = async () => {
  sendReportLoading.value = true;
  loading.value = true;
  try {
    const response = await ApiService.get(`/certification/status/${props.id}`);
    if (response.status === 200 && timeSmall.value && response.data.data.url === null) {
      await ApiService.get(`/certification/disapproved/${props.id}`);
      // Redireciona para o próximo step dinamicamente (geralmente feedback)
      const nextRoute = getNextStepRoute();
      if (nextRoute) {
        await router.push({ name: nextRoute, params: {id: props.id} });
      } else {
        // Fallback para feedback
        await router.push({ name: 'certifications-feedback', params: {id: props.id} });
      }
    }
  } catch (e) {
    console.error("Erro ao redirecionar:", e);
  } finally {
    sendReportLoading.value = false;
    loading.value = false;
  }
}

const formatDate = (date: Date | string) => formatBrasilia(date as any);

// Computed para somar todos os deadline_days dos steps de report
const totalDeadlineDays = computed(() => {
  if (!steps.value || steps.value.length === 0) return 7; // fallback
  
  // Para o componente de report, podemos somar apenas os steps de report
  // ou o step atual de report especificamente
  const reportStep = steps.value.find(step => step.component === 'certification_report');
  if (reportStep && reportStep.deadline_days) {
    return reportStep.deadline_days;
  }
  
  return 7; // fallback
});

// Computed para formatar o texto de dias (singular/plural)
const deadlineDaysText = computed(() => {
  const days = totalDeadlineDays.value;
  return days === 1 ? `${days} dia corrido` : `${days} dias corridos`;
});

const redirectSendReport = async () => {
  sendReportLoading.value = true;
  loading.value = true;
  try {
    // Carrega dados da certificação para validar step atual
    await loadCertificationData();
    
    // Se não está no step correto para este componente, redireciona
    if (!isOnCorrectStep.value) {
      // Se está em step anterior, redireciona para a rota anterior
      const previousRoute = getPreviousStepRoute();
      if (previousRoute && currentStep.value < (expectedStepForComponent.value || 0)) {
        await router.push({ name: previousRoute, params: {id: props.id}});
        return;
      }
      
      // Se está em step posterior (já enviou relatório), redireciona para próximo
      const nextRoute = getNextStepRoute();
      if (nextRoute && currentStep.value > (expectedStepForComponent.value || 0)) {
        await router.push({name: nextRoute, params: {id: props.id}});
        return;
      }
      
      // Se não consegue determinar rota, volta para listagem
      await router.push({name: 'certifications'});
      return;
    }
    
    // Está no step correto, pode continuar
    sendReportLoading.value = false;
    loading.value = false;
  } catch (e: any) {
    console.error("Erro ao redirecionar:", e);
    if(e.response?.data?.message === "Relatório já enviado, aguarde a avaliação"){
      const nextRoute = getNextStepRoute();
      if (nextRoute) {
        await router.push({name: nextRoute, params: {id: props.id}});
      } else {
        await router.push({name: 'certifications-feedback', params: {id: props.id}});
      }
      sendReportLoading.value = false;
      loading.value = false;
    }else if(e.response?.data?.message === "certificado ainda não iniciado" ){
      await router.push({name: 'certifications'});
    }
  } finally {
    sendReportLoading.value = false;
    loading.value = false;
  }
}

onMounted(async () => {
  await loadCertificationData();
  await redirectSendReport();
  await getDeadlineSendReport();
})
const checkedTerms = () => {
  isChecked.value = !isChecked.value;
  terms.value = isChecked.value;
}

const handleFileUpload = (event) => file.value = event.target.files[0] || null;

const submitFiles = async () => {
  sendReportLoading.value = true;
  if (!file.value) {
    console.error("Nenhum arquivo selecionado.");
    sendReportLoading.value = false;
    return;
  }
  if (file.value.type !== "application/pdf") {
    console.error("O arquivo não é um PDF.");
    sendReportLoading.value = false;
    return;
  }
  const formData = new FormData();
  formData.append('report', file.value);
  try {
    await ApiService.vueInstance.axios.post(`/certification/send-report/${props.id}`, formData);
    
    // Avança para o próximo step após envio bem-sucedido
    await ApiService.post(`/certification/${props.id}/advance-step`, {});
    
    // Apenas redireciona se o envio foi bem-sucedido
    file.value = null;
    
    window.location.reload();
  } catch (error) {
    console.error("Erro ao enviar o arquivo:", error);
    sendReportLoading.value = false;
  } finally {
    sendReportLoading.value = false;
  }
}
const removeFile = () => {
  file.value = null
}

watch(file, (newValue, oldValue) => {
  if (newValue && newValue.type === "application/pdf") {
    isFile.value = true;
  } else {
    console.error("O arquivo não é um PDF ou nenhum arquivo foi selecionado.");
    isFile.value = false;
  }
}, { deep: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (!sendReportLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(reportTitle) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.send_report.title`)), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(reportMessage))
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(reportMessage)), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.description`)), 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.report_preparation`)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.the_report_must_be_submitted_in_PDF_format`)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.name_the_file_following_the_pattern`)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.required_content`)), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.required_content_desc_1`)), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.required_content_desc_2`)), 1)
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline`)), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.deadline_desc_1`)) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(deadlineSendReport.value === undefined || !_unref(created_at).value ? '00/00/0000 00:00' : formatDate(_unref(created_at).value)) + "h", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.deadline_desc_2`)) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(deadlineSendReport.value === undefined ? '00/00/0000 00:00' : formatDate(deadlineSendReport.value)) + "h", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.deadline_desc_3`)) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_unref(deadlineDaysText)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.deadline_desc_4`)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.day`)), 1),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(timeRemaining.value.days.toString().padStart(2, '0')), 1)
                        ]),
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hours`)), 1),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(timeRemaining.value.hours.toString().padStart(2, '0')), 1)
                        ]),
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, _toDisplayString(timeRemaining.value.minutes.toString().padStart(2, '0')), 1)
                        ]),
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, _toDisplayString(timeRemaining.value.seconds.toString().padStart(2, '0')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("h2", _hoisted_49, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.upload_file`)) + " PDF ", 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("input", {
                    type: "file",
                    id: "file",
                    onChange: handleFileUpload,
                    hidden: ""
                  }, null, 32),
                  _createElementVNode("label", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.choose_the`)) + " PDF ", 1)
                  ])
                ]),
                (file.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", null, [
                          _hoisted_57,
                          _createElementVNode("span", _hoisted_58, _toDisplayString(file.value.name), 1)
                        ]),
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (removeFile())),
                          class: "cursor-pointer mt-1"
                        }, _hoisted_60)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", null, [
                          _hoisted_63,
                          _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.no_file_selected`)), 1)
                        ]),
                        _hoisted_65
                      ])
                    ])),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      (!isFile.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.choose_the`)) + " PDF", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.congratulations_the_file_is_a_PDF`)), 1))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      (isFile.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: submitFiles,
                            class: "upload-btn"
                          }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.send_report`)), 1))
                        : (_openBlock(), _createElementBlock("button", _hoisted_77, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.send_report`)), 1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("span", _hoisted_81, "    " + _toDisplayString(loading.value ? _ctx.$t(`${_unref(currentLanguage)}.certification.send_report.analyzing`) : _ctx.$t(`${_unref(currentLanguage)}.certification.send_report.sending`)) + " " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.send_report.report`)) + "... ", 1)
          ])
        ]))
  ], 64))
}
}

})